import { createContext } from 'react';
import type { WebPlatform } from '@lib/pwa/install-utils';

export interface InstallPromptContextValue {
  isOpen: boolean;
  shouldPrompt: boolean;
  isInstalling: boolean;
  isInstalled: boolean;
  hasDeferredPrompt: boolean;
  platform: WebPlatform;
  canInstall: boolean;
  show: () => void;
  forceShow: () => void;
  handleInstall: () => Promise<void>;
  handleDismiss: () => void;
}

export const InstallPromptContext = createContext<InstallPromptContextValue | undefined>(undefined);
